import type { Column } from '@platform/design-system';
import { deliveryRateOf } from '../dashboard/performance.ts';
import type { StatisticsFormat } from './statistics.ts';

type Settled = { readonly delivered: number; readonly returned: number };

export const numericColumn = <Row>(id: string, header: string, cell: (row: Row) => string): Column<Row> => ({
  id,
  header,
  numeric: true,
  cell,
});

export const deliveryRateColumn = <Row extends Settled>(
  header: string,
  format: StatisticsFormat,
): Column<Row> => numericColumn('deliveryRate', header, (row) => format.rate(deliveryRateOf(row)));
